import classNames from "./styles.module.scss"
import { useEffect, useState } from 'react';
import { MapModule } from "../../features/fias-map/ui";
import { Feature } from "ol";
import { LayersFilter } from "../../features/fias-layers-filter";
import { GetContact } from "../../features/fias-get-contact";
import { FiasSearch } from "../../features/fias-search";
import { FeaturePopup } from "../../features/feature-popup";
import { Watermark } from "../../features/watermark";
import { getRegions } from "./../../shared/RKApi";

interface Layerfilters {
  regions: boolean,
  municipals: boolean,
  settlement: boolean,
  cities: boolean,
  localities: boolean,
  streets: boolean,
  houses: boolean,
}

export const FiasPage = () => {
  const [map, SetMap] = useState<any>(null)
  const [drawEnabled, SetDrawEnabled] = useState(false)
  const [contactOpened, SetContactOpened] = useState<boolean | string>(false)
  const [regions, SetRegions] = useState<null|[any]>(null)
  const [regionsAval, SetRegionsAval] = useState<null|[any]>(null)
  const [baseLayersContainer, setBaseLayers] = useState<any>([
    {
        id: "osm",
        label: "OpenStreetMap",
        type: "OSM",
        url: "https://rk.geosamara.ru/mvtserver/RN_1_160/{z}/{x}/{y}.pbf",
        turned: true
    }
])

  const [onLayers, SetOnLayers] = useState<Layerfilters>({
    regions: false,
    municipals: false,
    settlement: false,
    cities: false,
    localities: false,
    streets: false,
    houses: false,
  })

  const [filtersActive, SetfiltersActive] = useState<boolean>(false)
  const [objectClick, SetObjectClick] = useState<{ opened: boolean, feature: Feature | null } | null>(null)

  useEffect(() => {
    getRegions(SetRegions)
  }, [])

  useEffect(() => {
    let avaliables:any = []
    regions?.forEach((reg)=> {
      if(reg && reg.available) {
        reg.available.forEach((elem:string) => {
          if (elem === "FiasGeocoded") avaliables.push(reg)
        });
      }
    })
    SetRegionsAval(avaliables)
  }, [regions])

  function setNewActiveArray(layers: Layerfilters) {
    SetOnLayers(layers)
    SetObjectClick(null)
  }

  function setObjectClick(feature: Feature | null) {
    SetObjectClick({ opened: true, feature: feature })
  }

  function setContactState(state: boolean, info: string | undefined) {
    SetfiltersActive(false)
    SetDrawEnabled(false)
    SetObjectClick(null)
    SetContactOpened(info ? info : state)
  }

  function getNameOfLayer(layers: Layerfilters) {
    let name = ''
    for (let layer in layers) {
      if (layers[layer as keyof Layerfilters]) name = layer
    }

    switch (name) {
      case 'regions':
        name = 'регионы'
        break;
      case 'municipals':
        name = 'муниципалитеты'
        break;
      case 'settlement':
        name = 'поселения'
        break;
      case 'cities':
        name = 'города'
        break;
      case 'localities':
        name = 'населенные пункты'
        break;
      case 'streets':
        name = 'улицы'
        break;
      case 'houses':
        name = 'дома'
        break;
      default:
        break;
    }
    return name
  }

  return (
    <>
      <div className={classNames.contentContainer}>
        
        <div id='topButton' className={classNames.topButton + ' ' + classNames.topButtonInMap}>
          <FiasSearch 
            SetObjectClick={SetObjectClick}
            regionsAvaliable={regionsAval}
            map={map}
            setInfoBlock={setObjectClick}
            setActive={setNewActiveArray}
          />
        </div>

        {/* <FeaturePopup
          map={map}
          info={objectClick}
          setContactState={setContactState}
        /> */}

        <MapModule
          setMap={SetMap}
          baseLayersContainer={baseLayersContainer}
          onLayers={onLayers}
          setMapOpened={() => {}}
          mapOpened={true}
          drawEnabled={drawEnabled}
          infoBlock={objectClick}
          setContactState={setContactState}
        />
        
        <div
          id="mapButton"
          className={classNames.mapButton + ' ' + classNames.mapButtonOpened}
          onClick={() => SetfiltersActive(!filtersActive)}
        >
            <div className={classNames.buttonTextPadding + ' ' + classNames.textInFilterButton}>
              Уровень:  <p className={classNames.titleLayerText}>{getNameOfLayer(onLayers) ? getNameOfLayer(onLayers) : 'выберите'}</p>
            </div>
          </div>
        
        <LayersFilter
          baseLayersContainer={baseLayersContainer}
          setBaseLayers={setBaseLayers}
          setOpened={filtersActive}
          layersActive={onLayers}
          setActive={setNewActiveArray} 
        />

        <GetContact opened={contactOpened} setContactState={setContactState} />
        <Watermark/>
      </div>
    </>
  );
}